import { render, staticRenderFns } from "./cardbag.vue?vue&type=template&id=2a6b9048&scoped=true&"
import script from "./cardbag.vue?vue&type=script&lang=js&"
export * from "./cardbag.vue?vue&type=script&lang=js&"
import style0 from "./cardbag.vue?vue&type=style&index=0&id=2a6b9048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b9048",
  null
  
)

export default component.exports